import {Form as MobxReactForm} from 'utils/mobx-react-form';
import validatorjs from 'validatorjs';
import dvr from 'mobx-react-form/lib/validators/DVR';

const plugins = {dvr: dvr(validatorjs)};

const fields = [
  {
    name: 'email',
    rules: 'string',
    options: {validateTrimmedValue: true}
  },
  {
    name: 'phoneNumber',
    rules: 'string',
    options: {validateTrimmedValue: true}
  },
  {
    name: 'resetCode',
    rules: 'string',
    options: {validateTrimmedValue: true}
  },
  {
    name: 'newPassword',
    rules: 'string',
    label: 'new password'
  },
  {
    name: 'newPasswordConfirm',
    rules: 'string',
    label: 'new password confirmation'
  }
];

export const createLocalisedForm = translations => new MobxReactForm({fields}, {plugins});
export default new MobxReactForm({fields}, {plugins});
